export function formatPrice(n: number, symbol?: string): string {
  return new Intl.NumberFormat("ru-RU").format(Math.round(n)) + "\u00A0" + (symbol ?? "\u20BD");
}

export function discountPercent(price: number, oldPrice: number | null | undefined): number {
  if (!oldPrice || oldPrice <= 0 || oldPrice <= price) return 0;
  return Math.round((1 - price / oldPrice) * 100);
}

const IMG_QUALITY = 80;

export function imgOpt(url: string, width: number): string {
  if (!url.includes("/storage/v1/object/public/")) return url;
  const base = url.replace("/object/public/", "/render/image/public/");
  const sep = base.includes("?") ? "&" : "?";
  return `${base}${sep}width=${width}&format=webp&quality=${IMG_QUALITY}`;
}
